import { render, staticRenderFns } from "./MessageCreator.html?vue&type=template&id=0d6cad4e&scoped=true&external"
import script from "./MessageCreator.js?vue&type=script&lang=js&external"
export * from "./MessageCreator.js?vue&type=script&lang=js&external"
import style0 from "./MessageCreator.scss?vue&type=style&index=0&id=0d6cad4e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6cad4e",
  null
  
)

export default component.exports